import axios from 'axios';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { TabView, TabPanel } from 'primereact/tabview';
import { Checkbox } from 'primereact/checkbox';
import { Card } from 'primereact/card';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { motion } from 'framer-motion';
import { NavLink, useNavigate, useParams } from 'react-router-dom';

const Users = () => {
    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const [UserName, setUserName] = useState('');
    const [UserLoginId, setUserLoginId] = useState('');
    const [UserPassword, setUserPassword] = useState('');
    const [UserStatus, setUserStatus] = useState(null);
    const [UserRole, setUserRole] = useState(null);
    const [UserSalaryAmount, setUserSalaryAmount] = useState('');
    const [UserSalaryType, setUserSalaryType] = useState('');
    const [UserId, setUserId] = useState(null);
    const [StoreId, setStoreId] = useState(null);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedPermissions, setSelectedPermissions] = useState(['Settings']);
    const [searchPermission, setSearchPermission] = useState('');
    const headers = apiHeadersJson;
    const toast = useRef(null);
    const { user_id } = useParams();
    const navigate = useNavigate();


    const routes = [
        { label: "Masters", routename: "Masters", headline: true },
        { label: "Store", routename: "Store" },
        { label: "Category", routename: "Category" },
        { label: "Products", routename: "Products" },
        { label: "Import Products", routename: "ImportProducts" },
        { label: "Expenses", routename: "Expenses" },
        { label: "Customers", routename: "Customers" },
        { label: "Users", routename: "Users" },
        { label: "Users List", routename: "UsersList" },
        { label: "Product List", routename: "ProductList" },
        { label: "Offer Time", routename: "OfferTime" },
        { label: "Suppliers", routename: "Suppliers" },
        { label: "Upis", routename: "Upis" },
        { label: "Entries", routename: "Entries", headline: true },
        { label: "Stock Transfer", routename: "StockTransfer" },
        { label: "Purchase", routename: "Purchase" },
        { label: "Sales", routename: "Sales" },
        { label: "Employee Sales", routename: "EmployeeSales" },
        { label: "Expenses Entry", routename: "ExpensesEntry" },
        { label: "Orders", routename: "OrdersEntry" },
        { label: "Return Entries", routename: "Return Entries", headline: true },
        { label: "Sales Return", routename: "SalesReturn" },
        { label: "Purchase Return", routename: "PurchaseReturn" },
        { label: "Reports", routename: "Reports", headline: true },
        { label: "Purchase Report", routename: "PurchaseReport" },
        { label: "Stock Transfer Report", routename: "StockTransferReport" },
        { label: "Purchase Return Report", routename: "PurchaseReturnReport" },
        { label: "Sales Report", routename: "SalesReport" },
        { label: "Employee Sales Report", routename: "EmployeeSalesReport" },
        { label: "Sales Return Report", routename: "SalesReturnReport" },
        { label: "Orders Report", routename: "OrdersReport" },
        { label: "Expenses Report", routename: "ExpensesReport" },
        { label: "Stock Report", routename: "StockReport" },
        { label: "Stock Valuation", routename: "StockValuation" },
        { label: "View", routename: "View", headline: true },
        { label: "View Sale", routename: "ViewSale" },
        { label: "View Order", routename: "ViewOrder" },
        { label: "View Purchase", routename: "ViewPurchase" },
        { label: "View Stock Transfer", routename: "ViewStockTransfer" },
        { label: "View Purchase Return", routename: "ViewPurchaseReturn" },
        { label: "View Sales Return", routename: "ViewSalesReturn" },
        { label: "View Employee Sales", routename: "ViewEmployeeSales" },
        { label: "Print", routename: "Print", headline: true },
        { label: "Print Purchase", routename: "PrintPurchase" },
        { label: "Print Sale", routename: "PrintSale" },
        { label: "Print Stock Transfer", routename: "StockTransferInvoice" },
        { label: "Print Order", routename: "PrintOrder" },
        { label: "Print Purchase Return", routename: "PrintPurchaseReturn" },
        { label: "Print Sale Return", routename: "SaleReturnInvoice" },
        { label: "Today's Print", routename: "TodaysPrint" },
        { label: "Stock Print", routename: "StockPrint" },
        { label: "Others", routename: "Others", headline: true },
        { label: "Dashboard", routename: "Dashboard" },
        { label: "Store Change", routename: "StoreChange" },
        { label: "View Purchase Amount", routename: "PurchaseAmount" },
        { label: "Settings", routename: "Settings" },
        { label: "Today's Sale", routename: "TodaySale" },
        { label: "Clear & Backup", routename: "ClearBackup" },
        { label: "Backup History", routename: "BackupHistory" },
    ];

    const UsersStatus = [
        { user_status_label: "Active", user_status_value: "active" },
        { user_status_label: "Inactive", user_status_value: "inactive" }
    ];

    const SalaryTypes = [
        { user_salary_label: "Daily", user_salary_value: "daily" },
        { user_salary_label: "Weekly", user_salary_value: "weekly" },
        { user_salary_label: "Monthly", user_salary_value: "monthly" }
    ];

    const UsersRole = [
        { user_role_label: "Admin", user_role_value: "admin" },
        { user_role_label: "Store Admin", user_role_value: "store_admin" },
        { user_role_label: "M.User", user_role_value: "m_user" },
        { user_role_label: "S.User", user_role_value: "s_user" },
        { user_role_label: "QR Device", user_role_value: "qr" },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const body = {
            user_name: UserName,
            user_role: UserRole,
            user_status: UserStatus,
            user_salary_amount: UserSalaryAmount,
            user_salary_type: UserSalaryType,
            login_id: UserLoginId,
            login_password: UserPassword,
            store_id: StoreId,
            user_id: UserId,
            permissions: selectedPermissions
        };

        try {
            const response = await axios.post(`${apiUrl}/User/CreateUser`, body, { headers });
            setLoading(false);
            const { success, message } = response.data;

            if (success) {
                handleResetForm();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    const getInfo = async () => {
        try {
            const response = await axios.get(`${apiUrl}/User/GetUserInfo`, { params: { user_id }, headers });
            const { success, data, message, permissions } = response.data;

            if (success) {
                setActiveIndex(0);
                setUserId(data[0].user_id);
                setUserName(data[0].user_name);
                setUserStatus(data[0].user_status);
                setUserPassword(data[0].login_password);
                setUserLoginId(data[0].login_id);
                setUserRole(data[0].user_role);
                setUserSalaryAmount(data[0].user_salary_amount);
                setUserSalaryType(data[0].user_salary_type);
                setStoreId(data[0].store_id);
                setSelectedPermissions(permissions);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleResetForm = () => {
        setUserId(null);
        setUserName('');
        setUserStatus('');
        setUserLoginId('');
        setUserPassword('');
        setUserRole('');
        setUserSalaryAmount('');
        setUserSalaryType('');
        setStoreId(null);
        setSelectedPermissions(['Settings']);
        if (user_id) {
            navigate(`/UsersList`);
        }
    };

    const fetchDropdownData = async () => {
        try {
            const storesRes = await axios.get(`${apiUrl}/Masters/GetStoreList`, { headers });
            setStores(storesRes.data.data || []);
        } catch (error) {
            console.error('Error fetching DropdownData:', error);
        }
    };

    useEffect(() => {
        fetchDropdownData();
    }, []);
    useEffect(() => {
        user_id && getInfo();
    }, [user_id]);

    const handleSelectChange = (setState, value) => {
        setState(value);
    };

    const onPermissionToggle = (permission) => {
        setSelectedPermissions(prev => {
            if (prev.includes(permission)) {
                return prev.filter(p => p !== permission);
            } else {
                return [...prev, permission];
            }
        });
    };

    const toggleAllInSection = (sectionRoutes, checked) => {
        setSelectedPermissions(prev => {
            const sectionPermissions = sectionRoutes
                .filter(route => !route.headline)
                .map(route => route.routename);

            if (checked) {
                return [...new Set([...prev, ...sectionPermissions])];
            } else {
                return prev.filter(p => !sectionPermissions.includes(p));
            }
        });
    };

    const tabChange = (e) => {
        setActiveIndex(e.index);
    };

    const groupRoutesByHeadline = () => {
        const grouped = [];
        let currentGroup = null;

        routes.forEach(route => {
            if (route.headline) {
                if (currentGroup) {
                    grouped.push(currentGroup);
                }
                currentGroup = {
                    headline: route.label,
                    routes: []
                };
            } else if (currentGroup) {
                currentGroup.routes.push(route);
            }
        });

        if (currentGroup) {
            grouped.push(currentGroup);
        }

        return grouped;
    };

    const filteredGroups = () => {
        const groups = groupRoutesByHeadline();

        if (!searchPermission) return groups;

        return groups.map(group => ({
            ...group,
            routes: group.routes.filter(route =>
                route.label.toLowerCase().includes(searchPermission.toLowerCase()) ||
                route.routename.toLowerCase().includes(searchPermission.toLowerCase())
            )
        })).filter(group => group.routes.length > 0);
    };

    const formVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: "easeOut"
            }
        }
    };

    const permissionItemVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: (i) => ({
            opacity: 1,
            x: 0,
            transition: {
                delay: i * 0.05,
                duration: 0.3
            }
        })
    };

    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="d-flex justify-content-between align-items-center my-4">
                <div className="main-heading">
                    <h6>Users</h6>
                </div>
                <div className="main-heading-right">
                    <h6>Management/Users</h6>
                </div>
            </div>

            <div className="card">
                <div className="bg-dark text-white p-3 rounded-top d-flex justify-content-between align-items-center">
                    <h4>User Management</h4>
                    <NavLink to={'/UsersList'} className="btn btn-secondary" >
                        <i className='pi pi-list' />
                    </NavLink>
                </div>

                <TabView
                    activeIndex={activeIndex}
                    onTabChange={tabChange}
                    scrollable
                    panelContainerClassName="p-0"
                >
                    <TabPanel header="User Details" leftIcon="pi pi-user me-2">
                        <motion.div
                            initial="hidden"
                            animate="visible"
                            variants={formVariants}
                            className="p-3"
                        >
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">User Name</label>
                                        <InputText
                                            type="text"
                                            value={UserName}
                                            className="w-100"
                                            onChange={(e) => setUserName(e.target.value)}
                                            required
                                            placeholder="Enter User Name"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Login Id</label>
                                        <InputText
                                            type="text"
                                            value={UserLoginId}
                                            className="w-100"
                                            onChange={(e) => setUserLoginId(e.target.value)}
                                            required
                                            placeholder="Enter Login Id"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Login Password</label>
                                        <InputText
                                            type="text"
                                            value={UserPassword}
                                            className="w-100"
                                            onChange={(e) => setUserPassword(e.target.value)}
                                            required
                                            placeholder="Enter Password"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">User Role</label>
                                        <Dropdown
                                            value={UsersRole.find((row) => row.user_role_value === UserRole) || null}
                                            onChange={(e) => handleSelectChange(setUserRole, e.value.user_role_value)}
                                            options={UsersRole}
                                            optionLabel="user_role_label"
                                            optionDisabled={(option) => option.user_role_value === 'admin'}
                                            placeholder="Select a Role"
                                            className="w-100"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Status</label>
                                        <Dropdown
                                            value={UsersStatus.find((row) => row.user_status_value === UserStatus) || null}
                                            onChange={(e) => handleSelectChange(setUserStatus, e.value.user_status_value)}
                                            options={UsersStatus}
                                            optionLabel="user_status_label"
                                            placeholder="Select a Status"
                                            className="w-100"
                                            required
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Store</label>
                                        <Dropdown
                                            value={stores.find((row) => row.store_id === StoreId) || null}
                                            onChange={(e) => handleSelectChange(setStoreId, e.value.store_id)}
                                            options={stores}
                                            optionLabel="store_name"
                                            placeholder="Select a Store"
                                            className="w-100"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Salary Type</label>
                                        <Dropdown
                                            value={SalaryTypes.find((row) => row.user_salary_value === UserSalaryType) || null}
                                            onChange={(e) => handleSelectChange(setUserSalaryType, e.value.user_salary_value)}
                                            options={SalaryTypes}
                                            optionLabel="user_salary_label"
                                            placeholder="Select a Salary Type"
                                            className="w-100"
                                        />
                                    </div>
                                    <div className="col-md-4 my-3">
                                        <label className="form-label">Salary Amount</label>
                                        <InputText
                                            type="number"
                                            value={UserSalaryAmount}
                                            className="w-100"
                                            onChange={(e) => setUserSalaryAmount(e.target.value)}
                                            placeholder="Enter Salary Amount"
                                        />
                                    </div>
                                </div>
                                <span className='small'>Ensure the permissions in the Permissions tab are correctly assigned before submitting the user.</span>
                                <div className="d-flex gap-3 mt-4">
                                    {!UserId ? (
                                        <Button
                                            type="submit"
                                            label={loading ? "Loading..." : "Submit"}
                                            className="p-button-success"
                                            loading={loading}
                                            disabled={!StoreId || !UserRole || !UserName || !UserPassword || !UserLoginId || !UserStatus || (selectedPermissions.length === 0)}
                                        />
                                    ) : (
                                        <>
                                            <Button
                                                type="submit"
                                                loading={loading}
                                                label={loading ? "Loading..." : "Update"}
                                                className="p-button-success"
                                                disabled={!StoreId || !UserRole || !UserName || !UserPassword || !UserLoginId || !UserStatus || (selectedPermissions.length === 0)}
                                            />
                                            <Button
                                                type="button"
                                                onClick={handleResetForm}
                                                loading={loading}
                                                label="Reset"
                                                className="p-button-secondary"
                                                disabled={loading}
                                            />
                                        </>
                                    )}
                                </div>
                            </form>
                        </motion.div>
                    </TabPanel>

                    <TabPanel header="Permissions" leftIcon="pi pi-key me-2">
                        <div className="p-3">
                            <div className="mb-4">
                                <h5>User Permissions</h5>
                                <p className="text-muted">Select the permissions to grant to this user</p>

                                <div className="p-inputgroup mt-3">
                                    <span className="p-inputgroup-addon">
                                        <i className="pi pi-search"></i>
                                    </span>
                                    <InputText
                                        placeholder="Search permissions..."
                                        value={searchPermission}
                                        onChange={(e) => setSearchPermission(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                {filteredGroups().map((group, groupIndex) => (
                                    <motion.div
                                        key={groupIndex}
                                        className="col-md-6 mb-4"
                                        custom={groupIndex}
                                        initial="hidden"
                                        animate="visible"
                                        variants={permissionItemVariants}
                                    >
                                        <Card
                                            title={
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>{group.headline}</span>
                                                    <Checkbox
                                                        inputId={`select-all-${groupIndex}`}
                                                        checked={group.routes.every(route =>
                                                            selectedPermissions.includes(route.routename))
                                                        }
                                                        onChange={(e) =>
                                                            toggleAllInSection(group.routes, e.checked)
                                                        }
                                                    />
                                                </div>
                                            }
                                            className="h-100"
                                        >
                                            <div className="permissions-list">
                                                {group.routes.map((route, routeIndex) => (
                                                    <motion.div
                                                        key={route.routename}
                                                        className="d-flex align-items-center mb-3"
                                                        custom={routeIndex}
                                                        initial="hidden"
                                                        animate="visible"
                                                        variants={permissionItemVariants}
                                                    >
                                                        <Checkbox
                                                            inputId={`perm-${route.routename}`}
                                                            checked={selectedPermissions.includes(route.routename)}
                                                            onChange={() => onPermissionToggle(route.routename)}
                                                        />
                                                        <label
                                                            htmlFor={`perm-${route.routename}`}
                                                            className="ms-2"
                                                        >
                                                            {route.label}
                                                        </label>
                                                    </motion.div>
                                                ))}
                                            </div>
                                        </Card>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default Users;
